import { DtoInclude } from "../../../core/store/dto/dto";
import { AccountObjectDto } from "../account-object/account-object.dto";

export class TaskDto extends AccountObjectDto {
    @DtoInclude
    title: string;
    @DtoInclude
    done: boolean;
    @DtoInclude
    dueDate: string;
    @DtoInclude
    claimedBy: string;
    @DtoInclude
    taskType: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.dto.ts